import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AuthService } from './auth.service';
import { switchMap } from 'rxjs/operators';
import { CondominiumService } from './condominium.service';

export interface Ticket {
  id: number;
  createDate: string;
  closingDate: string | null;
  requester: {
    username: string;
    name: string;
  };
  title: string;
  body: string;
  status: 'OPEN' | 'IN_PROGRESS' | 'CLOSED';
  closedBy: {
    username: string;
    name: string;
  } | null;
  condominiumId: number;
}

export interface TicketPage {
  _embedded: {
    getTicketList: Ticket[];
  };
  _links: any;
  page: {
    size: number;
    totalElements: number;
    totalPages: number;
    number: number;
  };
}

export interface CreateTicketRequest {
  title: string;
  body: string;
  condominiumId: number;
}

export interface UpdateTicketStatusRequest {
  status: 'OPEN' | 'IN_PROGRESS' | 'CLOSED';
}

@Injectable({
  providedIn: 'root'
})
export class TicketService {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private condominiumService: CondominiumService
  ) { }

  getTickets(condominiumId: number, page: number = 0, size: number = 5, statuses: string[] = ['OPEN', 'IN_PROGRESS']): Observable<TicketPage> {
    return this.authService.getPKCEToken().pipe(
      switchMap(token => {
        return this.http.get<TicketPage>(`${environment.apiUrl}/tickets/condominium/${condominiumId}`, {
          headers: {
            Authorization: `Bearer ${token}`
          },
          params: {
            page: page.toString(),
            size: size.toString(),
            status: statuses
          }
        });
      })
    );
  }

  getTicket(id: number): Observable<Ticket> {
    return this.authService.getPKCEToken().pipe(
      switchMap(token => {
        return this.http.get<Ticket>(`${environment.apiUrl}/tickets/${id}`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
      })
    );
  }

  createTicket(request: CreateTicketRequest): Observable<Ticket> {
    return this.authService.getPKCEToken().pipe(
      switchMap(token => {
        return this.http.post<Ticket>(`${environment.apiUrl}/tickets/`, request, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
      })
    );
  }

  updateTicketStatus(id: number, request: UpdateTicketStatusRequest): Observable<Ticket> {
    return this.authService.getPKCEToken().pipe(
      switchMap(token => {
        return this.http.patch<Ticket>(`${environment.apiUrl}/tickets/${id}/status`, request, {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });
      })
    );
  }
}
